import { API_URL } from 'common/consts/api';

class ApiService {
  async sendContactForm({ name, company, email, source, url, referrer, to }) {
    return fetch(API_URL.CONTACT, {
      method: 'POST',
      body: JSON.stringify({
        from: {
          fullName: name,
          company,
          email: email
        },
        url,
        source,
        referrer,
        to: to || 'default'
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }
}

export default new ApiService();



// WEBPACK FOOTER //
// ./src/services/Api.service.js